export enum FeatureInfoType {
  Point = 'Point',
  Line = 'Line',
  Polygon = 'Polygon',
}

export enum MeasurementType {
  Units = 'Units',
  Format = 'Format',
}

export enum CoordinateFormatType {
  UTM = 'Universal Transverse Mercator',
  DecimalDegrees = 'Decimal Degrees',
  DegreesMinutesSeconds = 'Degrees Minutes Seconds',
}

export enum LineMeasurementUnit {
  Millimeters = 'Millimeters',
  Centimeters = 'Centimeters',
  Meters = 'Meters',
  Kilometers = 'Kilometers',
  Inches = 'Inches',
  Feet = 'Feet',
  Yards = 'Yards',
  Miles = 'Miles',
}

export enum PolygonMeasurementUnit {
  SquareCentimeters = 'Square Centimeters',
  SquareMeters = 'Square Meters',
  SquareKilometers = 'Square Kilometers',
  Hectares = 'Hectares',
  Acres = 'Acres',
  SquareFeet = 'Square Feet',
  SquareYards = 'Square Yards',
  SquareMiles = 'Square Miles',
}

export enum LineMeasurementType {
  Distance2D = '2D Distance',
  SurfaceDistance3D = '3D Surface Distance',
}

export enum PolygonMeasurementType {
  Area = '2D Area',
  SurfaceArea = '3D Surface Area',
  Perimeter = '2D Perimeter',
  SurfacePerimeter = '3D Surface Perimeter',
}

export enum TerrainIterationStatus {
  OutOfBounds = 'Out of bounds',
  Failed = 'DEM processing failed',
  Processing = 'DEM is processing',
  NotFound = 'DEM not found',
}

export enum DefaultCrs {
  Name = 'WGS84',
  EPSGCode = 4326,
}

export enum UnitSystemKey {
  Selected = 'selectedUnitSystem',
}
